import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { api, getToken, setToken } from "./api.js";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [booting, setBooting] = useState(true);

  const refreshUser = useCallback(async () => {
    if (!getToken()) {
      setUser(null);
      setBooting(false);
      return null;
    }
    try {
      const current = await api("/v1/me");
      setUser(current);
      return current;
    } catch (error) {
      if (error.status === 401) setToken(null);
      setUser(null);
      return null;
    } finally {
      setBooting(false);
    }
  }, []);

  useEffect(() => { refreshUser(); }, [refreshUser]);

  const authenticate = useCallback(async ({ email, password, register }) => {
    const response = await api(register ? "/v1/auth/email/register" : "/v1/auth/email/login", {
      method: "POST",
      body: { email, password }
    });
    setToken(response.token);
    setUser(response.user);
    return response.user;
  }, []);

  const logout = useCallback(async () => {
    try { await api("/v1/auth/session", { method: "DELETE" }); } catch { /* local logout still succeeds */ }
    setToken(null);
    setUser(null);
  }, []);

  const value = useMemo(() => ({ user, setUser, booting, authenticate, refreshUser, logout }), [
    user, booting, authenticate, refreshUser, logout
  ]);
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  const value = useContext(AuthContext);
  if (!value) throw new Error("useAuth debe usarse dentro de AuthProvider");
  return value;
}
